/**
 * PublicRouter - the router App.js renders outside the Authenticator.
 *
 * Phase 999.100 W4 (D-16 + W4-D-07): /about-ai is public + unauthenticated.
 * Drop 2 (5 Oct 2026, CMO review C-01, C-02):
 *   - /crisis renders here in public mode whenever nobody is signed in
 *     (App.js decides, keyed on auth state as well as the path).
 *   - A catch-all route does a full page load for any other path. A router
 *     navigation inside this tree (for example About AI to /crisis, or Back)
 *     used to match nothing and blank the page; now it reloads into whichever
 *     tree App.js picks for that path.
 */
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

import LoadingFallback from './LoadingFallback';

const AboutAIPage = React.lazy(() => import('../pages/AboutAIPage'));
const CrisisPage = React.lazy(() => import('../pages/CrisisPage'));

export function FullPageLoad() {
  const { pathname, search, hash } = useLocation();
  useEffect(() => {
    window.location.assign(`${pathname}${search}${hash}`);
  }, [pathname, search, hash]);
  return null;
}

export function PublicRoutes() {
  return (
    <Routes>
      <Route
        path="/about-ai"
        element={
          <React.Suspense fallback={<LoadingFallback variant="minimal" />}>
            <AboutAIPage />
          </React.Suspense>
        }
      />
      <Route
        path="/crisis"
        element={
          <React.Suspense fallback={<LoadingFallback variant="minimal" />}>
            <CrisisPage publicMode />
          </React.Suspense>
        }
      />
      <Route path="*" element={<FullPageLoad />} />
    </Routes>
  );
}

export default function PublicRouter() {
  return (
    <BrowserRouter>
      <PublicRoutes />
    </BrowserRouter>
  );
}
